import styles from './LinearProgress.module.scss';

const LinearProgress: React.FunctionComponent = () => (
  <div className={styles.progressBar}>
    <div className={styles.progressBarValue}></div>
  </div>
);

export default LinearProgress;
